const IntervalsEnum = Object.assign({
  FINALMATURITY: 'finalMaturity',
  ANNUAL: 'annual',
  QUARTERLY: 'quarterly',
});

Object.freeze(IntervalsEnum);

export default IntervalsEnum;



// WEBPACK FOOTER //
// ./src/enum/financialProducts/Intervals.js